import { COLUMN } from 'components/dnd';

export const columnSource = {
  canDrag: () => true,
  isDragging: ({ name }, monitor) => monitor.getItem().name === name,
  beginDrag: ({ name, index }) => ({ name, index, type: COLUMN }),
};
